import React, { useState, useRef, useEffect } from "react";
import "../assets/styles/access.scss";
import { Col, Container, Row } from "react-bootstrap";
import percentageIcon from "../assets/images/percentage-icon.png";
import userIcon from "../assets/images/user-icon.svg";
import passIcon from "../assets/images/pass-icon.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "../helpers/smu-alerts/smu-lerts";
import _ from "lodash";
import { signIn } from "../api/auth";
import loadingGif from "../assets/images/loading.gif";
import { BIG_LOGO } from "../constants/images";
import useAuth from "../hooks/useAuth"
import interceptors from "../api/interceptors/index";

const Access = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [ip, setIP] = useState("");
  const { validate } = useAuth();

  const getData = async () => {

    const res = interceptors({
      url: "https://api.ipify.org/?format=json",
      method: "GET"
    });

    const value = await res
    setIP(value?.data?.ip)
  };

  useEffect(() => {
    getData();
  }, []);


  const trySignIn = (event) => {
    event.preventDefault();
    setLoading(true);

    // add encodeURI to avoid crashes with UTF 8 symbols
    signIn(btoa(encodeURI(username)), btoa(encodeURI(password)), ip)
      .then(({ data }) => {
        const { users: user } = _.omit(data, ["token"]);

        validate({ data });
        setLoading(false);

        navigate("/promotional-portal/portal/", { replace: true });
      })
      .catch(() => {
        setUsername("");
        setPassword("");
        setLoading(false);
        toast({
          icon: "error",
          title: "Usuario o contraseña incorrectos.",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Container className="py-5">
      <Row className="pb-5 px-4 h-100">
        <Col col={12} className="col-12 d-flex">
          <img src={BIG_LOGO} alt="LOGO V1" className="logo mx-auto mt-auto" />
        </Col>
        <Col col={12} md={5} lg={4} className="ms-auto d-flex">
          <div className="d-flex align-items-center my-auto">
            <img
              src={percentageIcon}
              alt="PERCENTAGE ICON"
              className="percentage-icon me-3"
            />
            <span className="text-percentage">Portal Promocional</span>
          </div>
        </Col>

        <Col col={12} md={1}>
          <div className="d-flex h-100">
            <div className="divider-vertical d-none d-md-block" />
            <div className="divider-horizontal d-block d-md-none" />
          </div>
        </Col>

        <Col col={12} md={5} lg={4} className="me-auto">
          <div className="d-flex h-100">
            <form className="mt-auto w-100" onSubmit={trySignIn}>
              <div className="title my-3 text-left">
                🏢 Ingrese sus datos para iniciar sesión:
              </div>
              <div className="control">
                <img src={userIcon} alt="ICON" />
                <input
                  type="text"
                  placeholder="Usuario"
                  required
                  value={username}
                  onChange={({ target }) => setUsername(target.value)}
                />
              </div>
              <div className="control">
                <img src={passIcon} alt="ICON" />
                <input
                  type="password"
                  placeholder="Contraseña"
                  required
                  value={password}
                  onChange={({ target }) => setPassword(target.value)}
                />
              </div>

              {!loading ? (
                <button type="submit" className="btn-signin">
                  Iniciar Sesión
                </button>
              ) : (
                <div className="signin-loading mb-5">
                  <img src={loadingGif} alt="Cargando" />
                  <span className="ms-3">Cargando...</span>
                </div>
              )}
            </form>
          </div>
        </Col>

        <div className="footer mt-5 mt-md-auto">
          <div className="text-footer mx-auto"></div>
        </div>
      </Row>
    </Container>
  );
};

export default Access;
